/**
 * 配置弹窗「按钮名称搜索」过滤（行星配置用）。
 *
 * 口径：
 *   1) 只匹配**名称**子串 —— 输入"相关字"就把"名字相似"的按钮留下，其余隐藏；
 *      如 "水" → 水星；"海" → 海王星；"谷" → 谷神星；
 *   2) 大小写不敏感、忽略首尾空白（"mc" 能命中 "Mc"）；
 *   3) 关键字为空（''、空白、null）时**原样返回全部** —— 没有查询就恢复全部内容；
 *   4) **不按编号匹配** —— 否则输入 "4" 会连 47、9000046 一起命中，属于"搜出无关项"。
 *
 * 边界：本模块只做**展示过滤**，不参与选中态、参与集合与任何请求参数，
 * 因此不会影响星盘生成结果。纯函数、无依赖，可在 node 里直跑单测。
 */

/** 关键字归一化：转字符串、去首尾空白、转小写 */
function normalizeKeyword (value) {
  if (value === undefined || value === null) {
    return ''
  }
  return String(value).trim().toLowerCase()
}

/** 单项是否命中关键字（关键字为空视为全部命中） */
function matchName (item, keyword) {
  const key = normalizeKeyword(keyword)
  if (!key) {
    return true
  }
  if (!item || typeof item !== 'object') {
    return false
  }
  const name = normalizeKeyword(item.name)
  return name !== '' && name.indexOf(key) >= 0
}

/**
 * 过滤列表（关键字为空时原样返回，保证"没有查询就恢复全部内容"）。
 * @param {Array} list 当前标签页的按钮列表
 * @param {string} keyword 关键字
 * @returns {Array} 名称命中的项（保持原顺序）
 */
function filterOptions (list, keyword) {
  if (!Array.isArray(list)) {
    return []
  }
  const key = normalizeKeyword(keyword)
  if (!key) {
    return list
  }
  return list.filter(item => matchName(item, key))
}

module.exports = {
  normalizeKeyword,
  matchName,
  filterOptions
}
